module.exports = __webpack_public_path__ + "static/media/TopDelivery2_2.bc8b6469.png";